import $ from "jquery/dist/jquery";

$(() => {
  function gaEecProductClick(i, prevented) {
    let d = {
      item_id: i.attr("data-ga-eec-id"),
      item_name: i.attr("data-ga-eec-name"),
      item_brand: i.attr("data-ga-eec-brand"),
      item_category: i.attr("data-ga-eec-category"),
      item_list_id: i.attr("data-ga-eec-list"),
      item_list_name: i.attr("data-ga-eec-list"),
      quantity: 1,
      price: i.attr("data-ga-eec-price"),
      currency: i.attr("data-ga-eec-currency"),
    };

    window.gtag("event", "select_item", {
      item_list_id: i.attr("data-ga-eec-list"),
      item_list_name: i.attr("data-ga-eec-list"),
      items: [d],
    });

    window.gtag("event", "ux_click", {
      name: "Klik na produkt",
      event_callback: () => {
        if (prevented) {
          document.location = i.attr("href");
        }
      },
    });
  }

  if (window.gtag) {
    let prevented = false;
    $(document).on("click", 'a[data-ga-eec="eec"]', function (e) {
      if (window.gtag?.loaded) {
        if (!(e.which > 1 || e.shiftKey || e.altKey || e.metaKey || e.ctrlKey)) {
          e.preventDefault();
          prevented = true;
        }
        gaEecProductClick($(this), prevented);
      }
    });
  }
});
